'use client'

import { BentoItemFragment } from '@/gql/generated/graphql'
import { BentoItem } from './bento-item'
import { OverlineHeader } from '@components/overline-header'
import { DisplayText } from 'design-configuration/components'

interface SpotlightBentoProps {
  items: BentoItemFragment[]
}

export function SpotlightBento({ items }: SpotlightBentoProps): React.ReactElement {
  if (items.length < 6) {
    return <></>
  }

  const bentoBoxName = 'Spotlight'

  return (
    <div className="py-md px-md md:py-2xl w-full">
      <div className="md:px-md">
        <OverlineHeader text="Take a closer look" />
        <DisplayText className="mt-sm mb-md">Art. Community. Technology.</DisplayText>
      </div>
      <div className="gap-md grid h-auto w-full grid-cols-1 sm:h-[500px] sm:grid-cols-2 md:h-[100vh] lg:grid-cols-3">
        <div className="col-span-1 h-[160px] sm:h-full lg:col-span-2">
          <BentoItem bentoItem={items[0]} bentoBoxName={bentoBoxName} bentoBoxPosition={0} />
        </div>
        <div className="col-span-1 h-[160px] sm:h-full">
          <BentoItem bentoItem={items[1]} bentoBoxName={bentoBoxName} bentoBoxPosition={1} />
        </div>
        <div className="col-span-1 h-[160px] sm:h-full">
          <BentoItem bentoItem={items[2]} bentoBoxName={bentoBoxName} bentoBoxPosition={2} />
        </div>
        <div className="col-span-1 h-[160px] sm:h-full">
          <BentoItem bentoItem={items[3]} bentoBoxName={bentoBoxName} bentoBoxPosition={3} />
        </div>
        <div className="gap-md col-span-1 hidden h-full flex-col lg:flex">
          <BentoItem bentoItem={items[4]} bentoBoxName={bentoBoxName} bentoBoxPosition={4} />
          <BentoItem bentoItem={items[5]} bentoBoxName={bentoBoxName} bentoBoxPosition={5} />
        </div>
        <div className="col-span-1 block h-[160px] sm:h-full lg:hidden">
          <BentoItem bentoItem={items[4]} bentoBoxName={bentoBoxName} bentoBoxPosition={4} />
        </div>
        <div className="col-span-1 block h-[160px] sm:h-full lg:hidden">
          <BentoItem bentoItem={items[5]} bentoBoxName={bentoBoxName} bentoBoxPosition={5} />
        </div>
      </div>
    </div>
  )
}
